<template>
    <div class="d-inline">
        <button @click.prevent="uploadModal = true" :class="thestyle">
            <slot></slot>
        </button>

        <modal v-if="uploadModal" @close="uploadModal = false" title="Upload image">
            <form v-if="!readonly" id="blockimageupload" @submit.prevent="uploadImage()">
                <transition name="fade">
                    <alert-bar v-if="msgtext" v-bind:class="msgclass" class="mw-650px mr-auto ml-auto">{{msgtext}}</alert-bar>
                </transition>
                <div>
                    <input placeholder="Voer afbeelding in" class="textinput mr-2 mb-4" type="file" name="field_blockimage" ref="file" v-on:change="handleFileUpload()">
                </div>
                <button type="submit" class="btn btn-primary"><loader v-if="loading" style="margin-bottom: -10px;"/><span v-if="!loading" >Uploaden</span></button>
            </form>
        </modal>
    </div>
</template>

<script>
import Modal from './Modal.vue';
import AlertBar from '../form/Alert.vue';
import Loader from '../ui/Loader.vue';

import { userService } from '../../services/user.service.js';
import { authHeader } from '../../services/auth-header.js';

import axios from 'axios';

export default {
    components:{
        Modal,
        AlertBar,
        Loader
    },
    props: {
        websiteid: String,
        returnvalue: Boolean,
        thestyle: String,
        pageid: String
    },
    data: function() {
        return{
            uploadModal: false,
            file: '',
            loading: false,
            imageroot: process.env.VUE_APP_ROOT_API + '/',
            msgtext: '',
            msgclass: 'error'
        }
    },
    methods: {
        handleFileUpload(){
            this.file = this.$refs.file.files[0];
        },
        uploadImage(){
            this.loading = true
            let formData = new FormData();
            formData.append('image', this.file)
            formData.append('websiteid', this.websiteid)
            formData.append('is_deleted', false)

            const requestOptions = {
              headers: authHeader()
            }

            axios.post(process.env.VUE_APP_ROOT_API+'/media/', formData, requestOptions)
            .then(
                response => {
                    if(this.returnvalue){
                        this.$emit('clicked', response.data.imageurl, this.pageid)
                    } else {
                        this.$emit('clicked')
                    }
                    this.uploadModal = false
                    this.file = ''
                    this.loading = false
                },
                error => {
                    this.msgtext = 'Upload afbeeldingen van max 5mb.'
                    this.loading = false
                }
            )
        }
    }
}
</script>
